import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Table, Input, Card, Modal } from 'antd'
import AdminHeader from '../CommonComponent/AdminHeader'
import Footer from '../CommonComponent/Footer'
import { EyeOutlined } from '@ant-design/icons'
import {
  ApprovedRegStudentList,
  ApprovePendingRegFeeList,
  IMG_BASE_URL,
  RegFeeApproveReject,
} from '../../AllAPI/AdminAPI'
import { toast } from 'react-toastify'

const RegApprovePendingList = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [loading1, setLoading1] = useState(false)

  const [viewModal, setViewModal] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [confirmModal, setConfirmModal] = useState(false)
  const [actionType, setActionType] = useState('') // 'approve' or 'reject'
  const [imagePreview, setImagePreview] = useState(null)
  const [rejectReasonModal, setRejectReasonModal] = useState(false)
  const [rejectReason, setRejectReason] = useState('')

  // =========Image CLick For Showing Big Size=================
  const handleImageClick = (img) => {
    setImagePreview(img)
  }

  const closePreview = () => {
    setImagePreview(null)
  }
  // ========================================

  useEffect(() => {
    fetchApprovePendingList()
  }, [])

  const fetchApprovePendingList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(ApprovePendingRegFeeList)
      setData(res.data)
    } catch (err) {
      console.log(err)
    }
    setLoading(false)
  }

  // ===== Search Filter =====
  const filteredData = data.filter((item) =>
    Object.values(item).join(' ').toLowerCase().includes(search.toLowerCase()),
  )

  // ACTION: OPEN MODAL
  const handleView = (record) => {
    setSelectedRecord(record)
    setViewModal(true)
  }

  const handleActionClick = (type) => {
    setActionType(type)
    setConfirmModal(true)
  }

  const handleConfirmAction = async () => {
    try {
      const today = new Date().toISOString().split('T')[0] // YYYY-MM-DD

      setLoading1(true)
      const body = {
        payment_status: actionType === 'approve' ? 1 : 2, // 1 = approve, 2 = reject
        reject_reason: actionType === 'reject' ? rejectReason : '',
        payment_approval_date: actionType === 'approve' ? today : '',
      }

      const res = await axios.put(
        `${RegFeeApproveReject}/${selectedRecord.reg_id}`,
        body,
      )

      if (res.data == 'UPDATED') {
        toast.success('Data Approved Successfully!')
        setConfirmModal(false)
        setViewModal(false)
        fetchApprovePendingList()
      } else if (res.data == 'REJECTED') {
        toast.success('Data Rejected Successfully!')
        setConfirmModal(false)
        setViewModal(false)
        fetchApprovePendingList()
      }
    } catch (error) {
      console.log(error)
    }
    setLoading1(false)
  }

  // ===== Table Columns =====
  // TABLE COLUMNS
  const columns = [
    {
      title: 'Sr No.',
      dataIndex: 'sr',
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
      width: 80,
    },
    {
      title: 'Student Name',
      render: (_, record) =>
        `${record.fname || ''} ${record.mname || ''} ${
          record.lname || ''
        }`.trim(),
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile',
      width: 130,
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },

    // ACTION COLUMN
    {
      title: 'Action',
      key: 'action',
      width: 90,
      render: (_, record) => (
        <EyeOutlined
          onClick={() => handleView(record)}
          style={{
            fontSize: '20px',
            cursor: 'pointer',
            color: '#1677ff',
          }}
        />
      ),
    },
  ]

  return (
    <div className="bg-gray-100 min-h-screen">
      <AdminHeader />

      <div className="row m-0 p-md-5 pt-0 mb-5">
        <div className="col-12 col-md-2"></div>

        <div className="col-12 col-md-8 pb-5">
          {/* Header */}
          <header className="reg-header pt-3">
            <h3 className="reg-title pt-1 pt-md-0">
              {' '}
              Reg. Approve Pending List{' '}
            </h3>
          </header>

          {/* Search Bar */}
          <div className="row m-0 p-0" style={{ marginTop: '10px' }}>
            <div className="col-12 col-md-8"></div>
            <div className="col-12 col-md-4">
              <Input
                placeholder="Search here..."
                size="large"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                }}
              />
            </div>
          </div>

          {/* Table */}
          <div style={{ marginTop: '10px' }}>
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              rowKey="id"
              // pagination={{
              //   pageSize: pageSize,
              //   current: currentPage,
              //   onChange: (page) => setCurrentPage(page),
              // }}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: (page) => {
                  setCurrentPage(page)
                },
                onShowSizeChange: (current, size) => {
                  setPageSize(size)
                  setCurrentPage(1) // reset page
                },
              }}
              bordered={true}
              className="custom-ant-table shadow border"
              style={{ background: 'white', borderRadius: '10px' }}
              scroll={{ x: 'max-content' }}
            />
          </div>

          {/* VIEW MODAL */}
          <Modal
            open={viewModal}
            onCancel={() => setViewModal(false)}
            title="Student Details"
            footer={null}
            width="110vw" // 👈 responsive wide
            style={{ top: 20 }}
            bodyStyle={{
              maxHeight: '80vh',
              overflowY: 'auto',
            }}
            className="custom-modal  mb-5 pb-5"
          >
            {selectedRecord && (
              <div className="row p-2 ">
                {/* --- FORM GRID --- */}
                <div className="row">
                  <div className="col-12 mt-2">
                    <label className="font-semibold">Full Name</label>
                    <Input
                      value={`${selectedRecord.fname} ${selectedRecord.mname} ${selectedRecord.lname}`}
                      readOnly
                    />
                  </div>

                  {selectedRecord.changed_name && (
                    <div className="col-12 mt-2">
                      <label className="font-semibold">Changed Name</label>{' '}
                      <br />
                      <Input
                        value={`${selectedRecord.changed_name}`}
                        readOnly
                      />
                    </div>
                  )}

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Email</label>
                    <Input value={selectedRecord.email} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Mobile</label>
                    <Input value={selectedRecord.mobile} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Gender</label>
                    <Input
                      value={selectedRecord.gender === 1 ? 'Male' : 'Female'}
                      readOnly
                    />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Date of Birth</label>
                    <Input value={selectedRecord.date_of_birth} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Blood Group</label>
                    <Input value={selectedRecord.blood_group} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Education</label>
                    <Input value={selectedRecord.education} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Occupation</label>
                    <Input value={selectedRecord.occupation} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Payment Amount</label>
                    <Input value={selectedRecord.payment_amount} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Payment Status</label>
                    <Input
                      value={selectedRecord.payment_status ? 'Paid' : 'Pending'}
                      readOnly
                    />
                  </div>

                  <div className="col-12 col-md-6 mt-2"></div>

                  {/* --- PROFILE PHOTO --- */}
                  <div
                    className="col-12 col-md-6 mt-2"
                    style={{ marginTop: '20px' }}
                  >
                    <label className="font-semibold">Profile Photo</label>
                    <div
                      style={{
                        border: '2px solid #a3a3a3ff',
                        width: '240px',
                        borderRadius: '8px',
                      }}
                    >
                      <img
                        src={`${IMG_BASE_URL}${selectedRecord.s_pic}`}
                        alt="Profile"
                        onClick={() =>
                          handleImageClick(
                            `${IMG_BASE_URL}${selectedRecord.s_pic}`,
                          )
                        }
                        style={{
                          width: '238px',
                          borderRadius: '8px',
                          objectFit: 'fill',
                          cursor: 'pointer',
                        }}
                      />
                    </div>
                  </div>

                  <div
                    className="col-12 col-md-6 mt-2"
                    style={{ marginTop: '20px' }}
                  >
                    <label className="font-semibold">Old Photo</label>
                    <div
                      style={{
                        border: '2px solid #a3a3a3ff',
                        width: '240px',
                        borderRadius: '8px',
                      }}
                    >
                      <img
                        src={`${IMG_BASE_URL}${selectedRecord.old_pic}`}
                        alt="Profile"
                        onClick={() =>
                          handleImageClick(
                            `${IMG_BASE_URL}${selectedRecord.old_pic}`,
                          )
                        }
                        style={{
                          width: '238px',
                          borderRadius: '8px',
                          objectFit: 'fill',
                          cursor: 'pointer',
                        }}
                      />
                    </div>
                  </div>

                  {/* --- PAYMENT SCREENSHOT --- */}
                  <div
                    className="col-12 col-md-6 mt-2"
                    style={{ marginTop: '20px', marginBottom: '20px' }}
                  >
                    <label className="font-semibold">Payment Screenshot</label>
                    <div
                      style={{
                        border: '2px solid #a3a3a3ff',
                        width: '260px',
                        borderRadius: '8px',
                      }}
                    >
                      <img
                        src={`${IMG_BASE_URL}${selectedRecord.payment_screenshot}`}
                        alt="Payment Screenshot"
                        onClick={() =>
                          handleImageClick(
                            `${IMG_BASE_URL}${selectedRecord.payment_screenshot}`,
                          )
                        }
                        style={{
                          width: '257px',
                          borderRadius: '8px',
                          cursor: 'pointer',
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '20px',
                    gap: '10px',
                  }}
                >
                  <button
                    onClick={() => handleActionClick('approve')}
                    style={{
                      background: '#52c41a',
                      color: 'white',
                      border: 'none',
                      padding: '8px 15px',
                      borderRadius: '5px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Approve
                  </button>

                  <button
                    // onClick={() => handleActionClick('reject')}
                    onClick={() => {
                      setActionType('reject')
                      setRejectReasonModal(true) // ⬅ open reason modal
                    }}
                    style={{
                      background: '#ff4d4f',
                      color: 'white',
                      border: 'none',
                      padding: '8px 15px',
                      borderRadius: '5px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Reject
                  </button>
                </div>
              </div>
            )}
          </Modal>

          <Modal
            open={confirmModal}
            onCancel={() => setConfirmModal(false)}
            onOk={handleConfirmAction}
            confirmLoading={loading1}
            title="Confirm Action"
          >
            <p>
              Are you sure you want to
              <b style={{ textTransform: 'capitalize' }}> {actionType} </b>
              this student?
            </p>
          </Modal>

          {/* ====REJECT REASON MODAL======= */}
          <Modal
            open={rejectReasonModal}
            title="Enter Reject Reason"
            onCancel={() => setRejectReasonModal(false)}
            onOk={() => {
              setRejectReasonModal(false)
              setConfirmModal(true) // open final confirm modal
            }}
          >
            <label>
              <b>Reason:</b>
            </label>
            <Input.TextArea
              rows={4}
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Enter reason here..."
            />
          </Modal>

          {imagePreview && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(0,0,0,0.7)',
                backdropFilter: 'blur(5px)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
              }}
              onClick={closePreview}
            >
              {/* CLOSE BUTTON */}
              <button
                onClick={closePreview}
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '30px',
                  fontSize: '30px',
                  background: 'transparent',
                  color: 'white',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                }}
              >
                ✖
              </button>

              {/* IMAGE */}
              <img
                src={imagePreview}
                alt="Preview"
                style={{
                  maxWidth: '90%',
                  maxHeight: '90%',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(255,255,255,0.5)',
                }}
                onClick={(e) => e.stopPropagation()} // stop closing when clicking image
              />
            </div>
          )}
        </div>

        <div className="col-12 col-md-2"></div>
      </div>

      <Footer />
    </div>
  )
}

export default RegApprovePendingList
